module.exports = __webpack_public_path__ + "img/progress_087.4316d572.png";